(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const cdnSwap = (url) => {
    if (!url || /\/cdn\/shop\/t\//i.test(url) || /shopifycloud/i.test(url)) return url;
    if (!/sandmarced\.com\/cdn\/shop\/(files|products|collections)\//i.test(url)) return url;
    return url.replace(/https?:\/\/(?:www\.)?sandmarced\.com\/cdn\//gi, "https://www.sandmarc.com/cdn/")
      .replace(/\/\/(?:www\.)?sandmarced\.com\/cdn\//gi, "https://www.sandmarc.com/cdn/");
  };
  document.addEventListener("error", (e) => {
    const el = e.target;
    if (!el || el.tagName !== "IMG" || el.dataset.cdnTried) return;
    const next = cdnSwap(el.currentSrc || el.src || "");
    if (!next || next === (el.currentSrc || el.src)) return;
    el.dataset.cdnTried = "1";
    if (el.getAttribute("srcset")) el.setAttribute("srcset", cdnSwap(el.getAttribute("srcset")));
    el.src = next;
  }, true);
  const announce = () => {
    const root = $("[data-announcement]");
    if (!root) return;
    const items = $$("[data-announcement-item]", root);
    if (items.length < 2) return;
    let i = 0;
    const show = (n) => items.forEach((el, idx) => { el.hidden = idx !== n; });
    show(0);
    const next = (dir = 1) => { i = (i + dir + items.length) % items.length; show(i); };
    $("[data-announcement-prev]", root)?.addEventListener("click", () => next(-1));
    $("[data-announcement-next]", root)?.addEventListener("click", () => next(1));
    setInterval(() => next(1), 5000);
  };
  const drawers = () => {
    const open = (id) => { const el = document.getElementById(id); if (!el) return; el.classList.add("is-open"); document.body.style.overflow = "hidden"; };
    const close = (el) => { el.classList.remove("is-open"); if (!$$(".drawer.is-open, .mobile-drawer.is-open, .search-drawer.is-open").length) document.body.style.overflow = ""; };
    document.addEventListener("click", (e) => {
      const opener = e.target.closest("[data-open]");
      if (opener) { e.preventDefault(); open(opener.getAttribute("data-open")); }
      const closer = e.target.closest("[data-close]");
      if (closer) { e.preventDefault(); const host = closer.closest(".drawer, .mobile-drawer, .search-drawer"); if (host) close(host); }
    });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") $$(".drawer.is-open, .mobile-drawer.is-open, .search-drawer.is-open").forEach(close); });
  };
  const carousels = () => {
    const nativeScroll = () => window.innerWidth <= 999;
    $$("[data-carousel]").forEach((root) => {
      const track = $("[data-track]", root);
      const slides = $$("[data-slide]", root);
      if (!track || !slides.length) return;
      let index = 0;
      const slideSize = () => {
        const slide = slides[0];
        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || "16") || 16;
        return slide.getBoundingClientRect().width + gap;
      };
      const visible = () => { const w = root.offsetWidth; if (w <= 768) return 1; if (w <= 999) return 2; return Number(root.dataset.visible || 4); };
      const update = () => {
        if (root.hidden) return;
        const vis = visible();
        const max = Math.max(0, slides.length - vis);
        index = Math.min(index, max);
        const prev = $("[data-prev]", root); const next = $("[data-next]", root);
        if (nativeScroll()) {
          track.style.transform = "";
          if (prev) prev.disabled = track.scrollLeft <= 4;
          if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
          return;
        }
        track.style.transform = `translateX(${-index * slideSize()}px)`;
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= max;
      };
      $("[data-prev]", root)?.addEventListener("click", () => {
        if (nativeScroll()) {
          track.scrollBy({ left: -slideSize(), behavior: "smooth" });
          return;
        }
        index = Math.max(0, index - 1);
        update();
      });
      $("[data-next]", root)?.addEventListener("click", () => {
        if (nativeScroll()) {
          track.scrollBy({ left: slideSize(), behavior: "smooth" });
          return;
        }
        index += 1;
        update();
      });
      track.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    });
  };
  const tabs = () => {
    $$("[data-tabs]").forEach((root) => {
      const buttons = $$("[data-tab]", root);
      const panels = $$("[data-panel]", root);
      buttons.forEach((btn) => btn.addEventListener("click", () => {
        buttons.forEach((b) => b.classList.toggle("is-active", b === btn));
        panels.forEach((p) => { p.hidden = p.dataset.panel !== btn.dataset.tab; });
        requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
      }));
    });
  };
  const activity = () => {
    const links = $$("[data-activity-link]");
    const imgs = $$("[data-activity-img]");
    links.forEach((link, i) => {
      const activate = () => { links.forEach((l) => l.classList.toggle("is-active", l === link)); imgs.forEach((img, n) => img.classList.toggle("is-active", n === i)); };
      link.addEventListener("mouseenter", activate);
      link.addEventListener("focus", activate);
    });
  };
  const money = (cents) => {
    try { return new Intl.NumberFormat(undefined, { style: "currency", currency: window.Shopify?.currency?.active || "USD" }).format(cents / 100); }
    catch { return `$${(cents / 100).toFixed(2)}`; }
  };
  const esc = (value) => String(value || "").replace(/[&<>"']/g, (ch) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  }[ch]));
  const qtyHtml = (item) => `<div class="qty cart-line__qty">
      <button type="button" data-cart-qty="${esc(item.key)}" data-next="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
      <span aria-live="polite">${item.quantity}</span>
      <button type="button" data-cart-qty="${esc(item.key)}" data-next="${item.quantity + 1}" aria-label="Increase quantity">+</button>
    </div>`;
  const cartLineHtml = (item) => {
    const unit = item.quantity ? item.final_line_price / item.quantity : item.final_price;
    const variant = item.variant_title && item.variant_title !== "Default Title"
      ? `<div class="cart-line__variant">${esc(item.variant_title)}</div>`
      : "";
    return `<div class="cart-line">
      <img src="${esc(item.image || "")}" alt="">
      <div>
        <a href="${esc(item.url)}">${esc(item.product_title)}</a>
        ${variant}
        ${qtyHtml(item)}
        <div class="cart-line__price">${money(item.final_line_price || unit * item.quantity)}</div>
      </div>
      <button type="button" data-cart-remove="${esc(item.key)}" aria-label="Remove">×</button>
    </div>`;
  };
  const renderCart = (cart) => {
    $$("[data-cart-count]").forEach((el) => { el.textContent = cart.item_count; el.classList.toggle("is-visible", cart.item_count > 0); });
    const body = $("[data-cart-items]");
    if (body) {
      body.innerHTML = cart.items.length
        ? cart.items.map(cartLineHtml).join("")
        : `<p>${body.dataset.empty || "Your cart is empty."}</p>`;
    }
    const total = $("[data-cart-total]");
    if (total) total.textContent = money(cart.total_price);
    const foot = document.querySelector("#cart-drawer .drawer__foot");
    if (foot) foot.hidden = !cart.item_count;
    const page = $("[data-cart-page]");
    if (page) {
      if (!cart.item_count) {
        if (page.dataset.hasItems === "true") window.location.reload();
        return;
      }
      $$(".cart-page-line", page).forEach((line) => {
        if (!cart.items.some((item) => item.key === line.dataset.lineKey)) line.remove();
      });
      cart.items.forEach((item) => {
        const line = page.querySelector(`[data-line-key="${item.key}"]`);
        if (!line) return;
        const qtyLabel = line.querySelector(".qty span");
        if (qtyLabel) qtyLabel.textContent = item.quantity;
        const buttons = line.querySelectorAll("[data-cart-qty]");
        if (buttons[0]) buttons[0].dataset.next = String(Math.max(0, item.quantity - 1));
        if (buttons[1]) buttons[1].dataset.next = String(item.quantity + 1);
        const price = line.querySelector(".cart-page-line__price");
        if (price) price.textContent = money(item.final_line_price);
      });
      const pageTotal = $("[data-cart-page-total]", page);
      if (pageTotal) pageTotal.textContent = money(cart.total_price);
    }
  };
  const refreshCart = async () => { const cart = await fetch("/cart.js").then((r) => r.json()); renderCart(cart); return cart; };
  const changeCart = async (id, quantity) => {
    const cart = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, quantity }),
    }).then((r) => r.json());
    renderCart(cart);
    return cart;
  };
  const cartActions = () => {
    let busy = false;
    document.addEventListener("submit", async (e) => {
      const form = e.target.closest("[data-product-form]");
      if (!form) return;
      e.preventDefault();
      await fetch("/cart/add.js", { method: "POST", body: new FormData(form) });
      await refreshCart();
      document.getElementById("cart-drawer")?.classList.add("is-open");
      document.body.style.overflow = "hidden";
    });
    document.addEventListener("click", async (e) => {
      const qtyBtn = e.target.closest("[data-cart-qty]");
      const removeBtn = e.target.closest("[data-cart-remove]");
      if (!qtyBtn && !removeBtn) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      try {
        if (qtyBtn) await changeCart(qtyBtn.dataset.cartQty, Number(qtyBtn.dataset.next));
        else await changeCart(removeBtn.dataset.cartRemove, 0);
      } finally {
        busy = false;
      }
    });
    refreshCart().catch(() => {});
  };
  const productGallery = () => {
    const mainImg = $("[data-gallery-main]");
    $$("[data-thumb]").forEach((btn) => {
      btn.addEventListener("click", () => {
        $$("[data-thumb]").forEach((b) => b.classList.toggle("is-active", b === btn));
        if (mainImg && btn.dataset.src) mainImg.src = btn.dataset.src;
      });
    });
    const form = $("[data-product-form]");
    const jsonEl = $("[data-product-json]");
    if (!form || !jsonEl) return;
    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch { return; }
    const idInput = form.querySelector('input[name="id"]');
    $$("[data-option-group]").forEach((group) => {
      $$("[data-option-value]", group).forEach((btn) => {
        btn.addEventListener("click", () => {
          $$("[data-option-value]", group).forEach((b) => b.classList.toggle("is-active", b === btn));
          update();
        });
      });
    });
    const update = () => {
      const values = $$("[data-option-group]").map((group) => $("[data-option-value].is-active", group)?.dataset.optionValue || "");
      const variant = product.variants.find((v) => values.every((val, i) => !val || String(v.options[i] || "") === val)) || product.variants[0];
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      const add = $("[data-add]", form);
      const stickyAdd = $("[data-sticky-add]");
      const label = variant.available ? "ADD TO CART" : "SOLD OUT";
      if (add) {
        add.disabled = !variant.available;
        add.textContent = label;
      }
      if (stickyAdd) {
        stickyAdd.disabled = !variant.available;
        stickyAdd.textContent = label;
      }
      const priceEl = $("[data-pdp-price]");
      const stickyPrice = $("[data-sticky-price]");
      const stickyImg = $("[data-sticky-img]");
      const html = variant.compare_at_price > variant.price
        ? `<span class="price__compare">${money(variant.compare_at_price)}</span><span class="price price--sale">${money(variant.price)}</span>`
        : `<span class="price">${money(variant.price)}</span>`;
      if (priceEl) priceEl.innerHTML = html;
      if (stickyPrice) stickyPrice.innerHTML = html;
      if (stickyImg && variant.featured_image) stickyImg.src = variant.featured_image.src;
      if (mainImg && variant.featured_image) mainImg.src = variant.featured_image.src;
    };
    update();
  };
  const qty = () => {
    document.addEventListener("click", (e) => {
      const step = e.target.closest("[data-step]");
      if (!step) return;
      const wrap = step.closest("[data-qty-pdp]");
      const input = wrap && wrap.querySelector("input[name='quantity']");
      if (!input) return;
      input.value = String(Math.max(1, Number(input.value || 1) + Number(step.dataset.step)));
    });
  };
  const stickyAtc = () => {
    const bar = $("[data-sticky-atc]");
    const trigger = $("[data-product-form] [type=submit]");
    if (!bar || !trigger) return;
    const pin = () => {
      if (window.innerWidth <= 999) {
        bar.style.top = "";
        return;
      }
      const header = $(".site-header");
      const bottom = header ? header.getBoundingClientRect().bottom : 64;
      bar.style.top = `${Math.round(Math.max(0, bottom))}px`;
    };
    new IntersectionObserver((entries) => {
      bar.classList.toggle("is-visible", !entries[0].isIntersecting);
      if (!entries[0].isIntersecting) pin();
    }, { threshold: 0 }).observe(trigger);
    window.addEventListener("scroll", pin, { passive: true });
    window.addEventListener("resize", pin);
    $("[data-sticky-add]")?.addEventListener("click", () => $("[data-product-form] [data-add]")?.click());
  };
  const faq = () => {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-faq-toggle]");
      if (!btn) return;
      const panel = document.getElementById(btn.getAttribute("aria-controls"));
      if (!panel) return;
      const open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!open));
      panel.hidden = open;
    });
  };
  const pdpEnhance = () => {
    $$(".ffba-tab-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const wrap = btn.closest(".ffba-wrap") || btn.closest(".pdp-story") || document;
        const target = btn.getAttribute("data-tab");
        const name = btn.getAttribute("data-name");
        $$(".ffba-tab-btn", wrap).forEach((b) => b.classList.remove("active"));
        $$(".ffba-panel", wrap).forEach((p) => p.classList.remove("active"));
        btn.classList.add("active");
        const heading = wrap.querySelector(".ffba-heading, #ffba-heading");
        if (heading && name) heading.textContent = name;
        const panel = wrap.querySelector("#ffba-" + target) || document.getElementById("ffba-" + target);
        if (panel) panel.classList.add("active");
      });
    });
    const lightbox = document.getElementById("ffba-lightbox");
    const lightboxImg = document.getElementById("ffba-lightbox-img");
    if (lightbox && lightboxImg) {
      document.addEventListener("click", (e) => {
        const img = e.target.closest(".ffba-image-wrap img");
        if (img) {
          lightboxImg.src = img.src;
          lightbox.classList.add("open");
          document.body.style.overflow = "hidden";
        }
        if (e.target === lightbox || e.target.closest("#ffba-lightbox-close")) {
          lightbox.classList.remove("open");
          lightboxImg.src = "";
          document.body.style.overflow = "";
        }
      });
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          lightbox.classList.remove("open");
          document.body.style.overflow = "";
        }
      });
    }
  };
  const search = () => {
    const input = $("[data-predictive-input]");
    const out = $("[data-predictive-results]");
    if (!input || !out) return;
    let t;
    input.addEventListener("input", () => {
      clearTimeout(t);
      t = setTimeout(async () => {
        const q = input.value.trim();
        if (q.length < 2) { out.innerHTML = ""; return; }
        const data = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`).then((r) => r.json());
        const products = data.resources?.results?.products || [];
        out.innerHTML = products.map((p) => `<a href="${p.url}" style="display:flex;gap:12px;align-items:center"><img src="${p.image || ""}" width="48" height="48" alt=""><span>${p.title}</span></a>`).join("");
      }, 200);
    });
  };
  announce(); drawers(); carousels(); tabs(); activity(); cartActions(); productGallery(); qty(); stickyAtc(); faq(); pdpEnhance(); search();
})();
